import { FC, useContext, useState, useCallback, useMemo, memo, useEffect } from "react";
import PriorityButton from "../../../assets/priorityButton.svg";
import ArrowDown from "../../../assets/arrowDown.svg";
import { UserMonitorContext } from "../../../pages/UserMonitor/UserMonitor";
import { IIdNameStyle, IIdNameStyleIcon } from "../../../models/FilterModels/IFilterModel";
import { ITag } from "../../../common/api_interfaces/tag/ITag";

const MonitorFastFilter: FC = memo(() => {
    const [showPriorities, setShowPriorities] = useState<boolean>(false);
    const [showTypes, setShowTypes] = useState<boolean>(false);

    const { changeFastFilters, selectedFastFilters, filters } = useContext(UserMonitorContext);

    const handlePriorityBtnClick = useCallback(() => {
        setShowPriorities(prev => !prev);
        setShowTypes(false);
    }, []);

    const handleClosePopups = useCallback(() => {
        setShowPriorities(false);
        setShowTypes(false);
    }, []);

    const handleSelectFilter = useCallback((filter: IIdNameStyle | ITag | IIdNameStyleIcon, filterType: "priority" | "type") => {
        const isSameFilter = selectedFastFilters[filterType]?.id === filter.id;
        const isResetFilter = filter.id === 0;

        if (isSameFilter || isResetFilter) {
            changeFastFilters({
                priority: filterType === "priority" ? undefined : selectedFastFilters.priority,
                type: filterType === "type" ? undefined : selectedFastFilters.type,
                tag: undefined,
            });
        } else {
            changeFastFilters({
                priority: filterType === "priority" ? (filter as IIdNameStyle) : selectedFastFilters.priority,
                type: filterType === "type" ? (filter as IIdNameStyleIcon) : selectedFastFilters.type,
                tag: undefined,
            });
        }
    }, [changeFastFilters, selectedFastFilters.priority, selectedFastFilters.type]);

    const handleSelectPriority = useCallback((priority: IIdNameStyle) => {
        handleSelectFilter(priority, "priority");
    }, [handleSelectFilter]);

    const priorityButtonText = useMemo(() => 
        selectedFastFilters.priority ? selectedFastFilters.priority.name : "Приоритет",
    [selectedFastFilters.priority]);

    const priorities = useMemo(() => filters?.priority || [], [filters?.priority]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (!target.closest('.board-filter-container')) {
                handleClosePopups();
            }
        };

        if (showPriorities || showTypes) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPriorities, showTypes, handleClosePopups]);

    return (
        <div className="board-fast-filters-container">
            <div className="board-filter-container">
                <button 
                    className="board-filter-container__priority" 
                    onClick={handlePriorityBtnClick}
                    type="button"
                >
                    <img src={PriorityButton} alt="Приоритет" />
                    {priorityButtonText}
                    <img src={ArrowDown} alt="Раскрыть" />
                </button>
                
                {showPriorities && (
                    <div>
                        <div className="fast-filters-popup-overlay" onClick={handleClosePopups}></div>
                        <div className="board-filter-dropdown" onClick={(e) => e.stopPropagation()}>
                            {priorities.map((priority) => (
                                <div
                                    key={priority.id}
                                    onClick={() => handleSelectPriority(priority)}
                                    className={`
                                        board-filter-dropdown__item
                                        ${selectedFastFilters.priority?.id === priority.id ? 'selected' : ''}
                                    `}
                                >
                                    {priority.name}
                                </div>
                            ))}
                            <div
                                onClick={() => handleSelectPriority({ id: 0, name: "Все", style: "" })}
                                className="board-filter-dropdown__item--del"
                            >
                                сбросить
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

MonitorFastFilter.displayName = 'MonitorFastFilter';

export default MonitorFastFilter;